import React, { useState, useEffect, useRef } from "react";
import { Button, Input, Select, message, Popconfirm } from "@cloud/atom-ui";
import css from "./index.m.css";
import LeftOutlined from "@cloud/atom-ui-icons/LeftOutlined";
import VersionOption from "./components/versionOption";
import ContentUpdate from "./components/contentUpdate";
import classNames from "classnames";
import { versionAnswer, handleGetSelected } from "../utils";
import { useLocation, useNavigate } from "react-router-dom";
import { queryString } from "@src/utils/common";
import PublishModal from "../publishModal";
import VisitableScope from "../visitableScope";
import { publishVersion } from "../thunk";
import { APP_WITHOUT_GUI } from "../constant";
const { Option } = Select;
import { APP_TYPE } from "@src/utils/common";
import TipsModal from "../component/tipsModal";
import history from "@src/utils/history";

export default props => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const appId = queryString("id") || "";
  const versionStatus = queryString("versionStatus") || "";
  const {
    changeVersionParam,
    updateContentList,
    versionParams,
    getVersionItem,
    savePublishVersion,
    publishModalVisible,
    setPublishModalVisible,
    withdrawalVersion,
    getVersionTableList,
    mobileList,
    pcList,
    paramsType,
    curVersionName,
  } = props;

  const [isErrorShow, setIsErrorShow] = useState({
    versionErrorShow: false,
    versionErrorText: "请输入正确版本号",
    updateErrorShow: false,
    updateErrorText: "请输入更新说明"
  });
  const versionShowRef = useRef(false);
  const [publishBtnLoading, setPublishBtnLoading] = useState(false); // 发布按钮加载状态
  const [isCheckModal, setIsCheckModal] = useState(null); //  当前点击的是 提交审核还是发布版本
  const [adminUserList, setAdminUserList] = useState([]);
  const [showAdminModal, setAdminModal] = useState(false);
  const currentVersion = state?.curVersionName || curVersionName; // 当前版本
  // 查询版本列表
  useEffect(() => {
    getVersionItem(state);
  }, []);

  const validVersion = value => {
    if (!versionAnswer(value, currentVersion)) {
      setIsErrorShow({
        ...isErrorShow,
        versionErrorShow: true,
        versionErrorText: "版本号必须比发布版本号大"
      });
      versionShowRef.current = false;
    } else {
      versionShowRef.current = true;
      setIsErrorShow({ ...isErrorShow, versionErrorShow: false });
    }
  };

  // 校验版本号
  const versionInput = e => {
    const { value } = e.target;
    let reg = /^\d{1,3}\.\d{1,3}\.\d{1,3}$/;
    if (!value) {
      setIsErrorShow({
        ...isErrorShow,
        versionErrorShow: true,
        versionErrorText: "请输入版本号"
      });
    } else if (!reg.test(value)) {
      setIsErrorShow({
        ...isErrorShow,
        versionErrorShow: true,
        versionErrorText: "请输入正确版本号"
      });
      versionShowRef.current = false;
    } else if (versionStatus === "update") {
      if (value === currentVersion) {
        versionShowRef.current = true;
        setIsErrorShow({ ...isErrorShow, versionErrorShow: false });
      } else {
        validVersion(value);
      }
    } else {
      validVersion(value);
    }
    changeVersionParam({ versionName: value });
  };

  // 校验更新说明
  const updatedVersion = e => {
    const { value } = e?.target;
    if (!value) {
      setIsErrorShow({
        ...isErrorShow,
        updateErrorShow: true,
        updateErrorText: "请输入更新说明"
      });
    } else {
      setIsErrorShow({
        ...isErrorShow,
        updateErrorShow: false
      });
    }
    changeVersionParam({ updateDescribe: value });
  };

  // 保存校验
  const submitVersion = () => {
    if (
      !versionParams.updateDescribe ||
      (!versionShowRef.current && versionStatus !== "update")
    ) {
      setIsErrorShow({
        ...isErrorShow,
        updateErrorShow: !versionParams.updateDescribe,
        updateErrorText: "请输入更新说明",
        versionErrorShow: !versionShowRef.current
      });
    } else if (isErrorShow.versionErrorShow || isErrorShow.updateErrorShow) {
      setIsErrorShow({ ...isErrorShow });
    } else {
      savePublishVersion();
    }
  };

  // 申请发布
  const publishCheckVersion = params => {
    publishVersion({ ...params }).then(result => {
      if (result && result.status === 1) {
        setPublishBtnLoading(false);
        setIsCheckModal(null);
        setPublishModalVisible(false);
        navigate(
          `/${paramsType}/appdetailV2/editionManage?id=${appId}&type=${paramsType}`
        );
      } else {
        message.error(result.errMsg || "发布失败，请稍后重试");
      }
    });
  };

  const handleUploadAuditFile = value => {
    let params = {};
    let AdminUsers = [];
    if (adminUserList && adminUserList.length > 0) {
      let result = adminUserList.map(a => a.accountId);
      AdminUsers = result;
    }
    if (value === "Gray") {
      params = { isGray: true, reviewAdminUsers: AdminUsers, appId: appId };
      publishCheckVersion(params);
    } else {
      params = { reviewAdminUsers: AdminUsers, appId: appId };
      if (!publishBtnLoading) {
        setPublishBtnLoading(true);
        publishCheckVersion(params);
      }
    }
  };

  const handleSelectAdmin = () => {
    setAdminModal(true);
  };

  const deleteElement = (itemList, index) => {
    itemList.splice(index, 1);
    let list = [...itemList];
    setAdminUserList(list);
  };

  const handleCancel = () => {
    setPublishModalVisible(false);
    setIsCheckModal(null);
    setAdminUserList([]);
    navigate(
      `/${paramsType}/appdetailV2/editionManage?id=${appId}&type=${paramsType}`
    );
    getVersionTableList();
  };

  const handlePublish = () => {
    if (versionStatus === 'update') {
      submitVersion()
    }
    else {
      handleUploadAuditFile();
    }
  };

  const onSubmitPreAudit = () => {
    history.push(
      `/${paramsType}/appdetailV2/editionManage?id=${appId}&type=${paramsType}&versionStatus=preReview`,
      {
        state: {
          versionName: state?.versionName
        }
      }
    );
  };

  return (
    <div className={css["version_content"]}>
      <div className={css["btn-div"]}>
        <Button
          className={css["left-btn"]}
          type="default"
          icon={<LeftOutlined />}
          onClick={() => {
            navigate(
              `/${paramsType}/appdetailV2/editionManage?id=${appId}&type=${paramsType}`
            );
          }}
        >
          返回
        </Button>
        <div className={css["top_title"]}>基础信息</div>
        {paramsType === APP_TYPE.isv && state?.preReviewStatus === 0 ? (
          <Button
            style={{ width: 86 }}
            type="primary"
            onClick={() => onSubmitPreAudit()}
          >
            提交预审
          </Button>
        ) : (
          <div>{""}</div>
        )}
      </div>
      <div>
        <div className={css["create-main"]}>
          <div className={css["title-div"]}>
            <p className={css["title"]}>版本详情</p>
            {versionStatus === "update" && (
              <Button
                className={css["publish-btn"]}
                type="primary"
                onClick={() => {
                  handlePublish();
                }}
              >
                {paramsType == APP_TYPE.isv ? "保存" : "发布"}
              </Button>
            )}
            {versionStatus === "underReview" && (
              <Popconfirm
                title="撤回后会中断管理员的审核"
                onConfirm={() => {
                  withdrawalVersion(appId);
                }}
              >
                <Button className={css["publish-btn"]} type="primary">
                  撤回版本
                </Button>
              </Popconfirm>
            )}
          </div>
          <p className={css["create-tip"]}>
            应用版本可设置应用版本号、应用能力和应用可用范围，所有变更需要保存并发布后才会正式生效，请谨慎操作
          </p>
          <div style={{ position: "relative" }}>
            <VersionOption isRequired versionTitle="应用版本号">
              <Input
                className={classNames(css["version-input"], {
                  [css["verify-input-border"]]: isErrorShow.versionErrorShow
                })}
                disabled={
                  versionStatus === "view" || versionStatus === "underReview"
                }
                placeholder={`对外展示的正式版本号、上一个版本号为${currentVersion ||
                  "1.0.0"}`}
                onChange={e => {
                  versionInput(e);
                }}
                defaultValue={
                  versionStatus !== "create" ? state?.versionName : ""
                }
              />
              {isErrorShow.versionErrorShow && (
                <span className={css["verify-input-tip"]}>
                  {isErrorShow.versionErrorText}
                </span>
              )}
            </VersionOption>
            <VersionOption versionTitle="移动端默认能力">
              <Select
                className={css["capability-select"]}
                placeholder={"请选择"}
                value={versionParams.mobileCapability || APP_WITHOUT_GUI}
                onChange={value => {
                  changeVersionParam({ mobileCapability: value });
                }}
                disabled={
                  versionStatus === "view" || versionStatus === "underReview"
                }
              >
                {mobileList.map((item, index) => {
                  return (
                    <Option value={item.type} key={index}>
                      {item.name}
                    </Option>
                  );
                })}
              </Select>
            </VersionOption>
            <VersionOption versionTitle="PC端默认能力">
              <Select
                className={css["capability-select"]}
                placeholder={"请选择"}
                value={versionParams.pcCapability || APP_WITHOUT_GUI}
                onChange={value => {
                  changeVersionParam({ pcCapability: value });
                }}
                disabled={
                  versionStatus === "view" || versionStatus === "underReview"
                }
              >
                {pcList.map((item, index) => {
                  return (
                    <Option value={item.type} key={index}>
                      {item.name}
                    </Option>
                  );
                })}
              </Select>
            </VersionOption>
            <VersionOption isRequired versionTitle="更新说明">
              <Input.TextArea
                className={classNames(css["description-input"], {
                  [css["verify-textarea-border"]]: isErrorShow.updateErrorShow
                })}
                placeholder={"此应用将于应用更新日志中展示"}
                maxLength={150}
                showCount
                value={versionParams?.updateDescribe || ""}
                onChange={e => {
                  updatedVersion(e);
                }}
                defaultValue={
                  versionStatus !== "create"
                    ? versionParams?.updateDescribe
                    : ""
                }
                disabled={
                  versionStatus === "view" || versionStatus === "underReview"
                }
              />
              {isErrorShow.updateErrorShow && (
                <span className={css["verify-textarea-tip"]}>
                  {isErrorShow.updateErrorText}
                </span>
              )}
            </VersionOption>
            <VersionOption versionTitle="待发布内容">
              <ContentUpdate updateContentList={updateContentList} />
            </VersionOption>
          </div>
          {versionStatus === "create" && (
            <div style={{ marginLeft: 130, marginTop: 32 }}>
              <Button
                style={{ marginRight: 16 }}
                className={css["publish-btn"]}
                type="primary"
                onClick={() => {
                  submitVersion();
                }}
              >
                保存
              </Button>
              <Button
                style={{ width: 86, height: 35 }}
                type="default"
                className={css["left-btn"]}
                onClick={() => {
                  navigate(
                    `/${paramsType}/appdetailV2/editionManage?id=${appId}&type=${paramsType}`
                  );
                }}
              >
                取消
              </Button>
            </div>
          )}
        </div>
      </div>
      {/* 内部应用发布弹窗 */}
      {publishModalVisible && paramsType === APP_TYPE.innerapp && (
        <PublishModal
          publishModalVisible={publishModalVisible}
          handleUploadAuditFile={handleUploadAuditFile}
          handleCancel={handleCancel}
          publishBtnLoading={publishBtnLoading}
          handleSelectAdmin={handleSelectAdmin}
          deleteElement={deleteElement}
          adminUserList={adminUserList}
          isCheckModal={isCheckModal}
        />
      )}
      {/* 三方应用发布弹窗 */}
      {publishModalVisible && paramsType === APP_TYPE.isv && (
        <TipsModal
          visible={publishModalVisible}
          modalInfo={{
            title: "提交预审",
            okText: "提交预审",
            cancelText: "取消"
          }}
          handleOk={() => {
            navigate(
              `/${paramsType}/appdetailV2/editionManage?id=${appId}&type=${paramsType}&versionStatus=preReview`
            );
          }}
          handleCancel={handleCancel}
        >
          <p>应用需提交预审后才能申请上架</p>
        </TipsModal>
      )}
      {showAdminModal && (
        <VisitableScope
          showAdminModal={showAdminModal}
          adminUserData={adminUserList}
          closeModel={() => {
            setAdminModal(false);
          }}
          getSelected={value => {
            setAdminUserList(handleGetSelected(value));
          }}
          id={appId}
        />
      )}
    </div>
  );
};
